import { CheckoutStepKey } from "@/lib/types/global"

type CheckoutStepCompletion = {
  addressesComplete: boolean
  pickupComplete: boolean
  paymentComplete: boolean
}

const checkoutStepOrder = [
  CheckoutStepKey.ADDRESSES,
  CheckoutStepKey.PICKUP,
  CheckoutStepKey.PAYMENT,
  CheckoutStepKey.REVIEW,
]

export const normalizeCheckoutStep = (step: unknown): CheckoutStepKey => {
  if (step === "delivery") {
    return CheckoutStepKey.PICKUP
  }

  if (
    typeof step === "string" &&
    checkoutStepOrder.includes(step as CheckoutStepKey)
  ) {
    return step as CheckoutStepKey
  }

  return CheckoutStepKey.ADDRESSES
}

export const getCheckoutStepIndex = (step: CheckoutStepKey) => {
  return checkoutStepOrder.indexOf(step)
}

export const getCheckoutRedirectStep = (
  currentStep: CheckoutStepKey,
  {
    addressesComplete,
    pickupComplete,
    paymentComplete,
  }: CheckoutStepCompletion,
) => {
  const currentStepIndex = getCheckoutStepIndex(currentStep)

  if (currentStepIndex < 0) {
    return CheckoutStepKey.ADDRESSES
  }

  if (currentStepIndex > 0 && !addressesComplete) {
    return CheckoutStepKey.ADDRESSES
  }

  if (currentStepIndex > 1 && !pickupComplete) {
    return CheckoutStepKey.PICKUP
  }

  if (currentStepIndex > 2 && !paymentComplete) {
    return CheckoutStepKey.PAYMENT
  }

  return null
}
